<template>
  <div v-if="order">
    <!-- 検索キーワード -->
    <v-card-text>
      <v-row>
        <v-col cols="12" md="12">
          <div class="overline">
            検索キーワード
          </div>
          <h4>
            {{ order.keyword || '-' }}&nbsp;
          </h4>
          <v-divider />
        </v-col>
      </v-row>

    </v-card-text>
  </div>
</template>

<script>

export default {
  name: 'BlockKeyword',
  components: {},
  mixins: [],
  props: {
    order: {
      type: Object,
      default: () => null
    },
  },
  data() {
    return {
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">

</style>
